const _ = require('lodash');
module.exports = {
	rules: {
		categoryContainsDiamondOrMountingsOrGold(record) {
			return _.includes(['diamond', 'gold', 'mountings'], record.category);
		},
		categoryIsDiamondOrGold(record) {
			return _.includes(['diamond', 'gold'], record.category);
		}
	},
	acl(user, defineAbility) {
		const ability = defineAbility((can, cannot) => {
			if (user.role === 'admin') {
				can('manage', 'Item');
			} else {
				cannot('manage', 'Item');
				can('read', 'Item');
			}
		});

		return { ability };
	}
};
